import axios from 'axios';

const baseUrl = 'https://aroundeverythingquery-production.up.railway.app'
const BASE_URL = 'https://baseutilities-production.up.railway.app';
const apiKey = 'AIzaSyCK_3jJMVlzXR0RwRKR354jyvQfqxf8NHA';

const MISSING_IMAGE_BASE64 =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMB/6X6k3sAAAAASUVORK5CYII=';
// export const convertToBase64 = (file) => {
//     return new Promise((resolve, reject) => {
//         const reader = new FileReader();
//         reader.readAsDataURL(file);
//         reader.onload = () => resolve(reader.result);
//         reader.onerror = (error) => reject(error);
//     });
// };
export const convertToBase64 = (file) => {
  return new Promise((resolve) => {
    // ❌ No file provided
    if (!file) {
      resolve(MISSING_IMAGE_BASE64);
      return;
    }

    // ❌ Not a File or Blob
    if (!(file instanceof Blob)) {
      resolve(MISSING_IMAGE_BASE64);
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      // ❌ Empty result
      if (!reader.result) {
        resolve(MISSING_IMAGE_BASE64);
      } else {
        resolve(reader.result);
      }
    };

    reader.onerror = () => {
      resolve(MISSING_IMAGE_BASE64);
    };

    try {
      reader.readAsDataURL(file);
    } catch {
      resolve(MISSING_IMAGE_BASE64);
    }
  });
};

export const getEvents = async () => {
    try {
        const response = await axios.get('https://aroundeverythingquery-production.up.railway.app/api/events')
        return response.data;
    } catch (error) {
        console.error(error);
        return;
    }
};

export const getCompanies = async() => {
    try{
        const response = await axios.get(`${baseUrl}/api/companies`)
        return response.data;
    } catch (err) {
        console.error(err);
        console.error('getCompanies error');
        return;
    }
}

export const getCompaniesByName = async (query,limit=10) =>{
  if (!query || String(query).trim().length < 1) return [];

  try {
      const resp = await axios.get(`${baseUrl}/api/companies/search`, {
        params: { q: String(query).trim(), limit },
        timeout: 8000,
      });

      const data = resp.data;
      if (!Array.isArray(data)) return [];

      return data.map((c) => ({
        id: c?.id ?? null,
        name: c?.name ?? '',
        address: c?.address ?? '',
        description: c?.description ?? '',
        logo: c?.logo ?? null,
      }));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('getCompaniesByName error', err && err.toString ? err.toString() : err);
      return [];
    }
}



export const loginUser = async (username, password) => {
    try {
        const response = await axios.post(`${baseUrl}/api/user/login`, {
            username,
            password,
        });
        // console.log("Login response:", response.data);
        return response.data.userID;
    } catch (error) {
        if (error.response) {
            console.error('Login failed:', error.response.data.message || error.response.data.error);
        } else {
            console.error('Error logging in:', error.message);
        }
    }
}

export const getUserCompByUser = async(id) => {
    try{
        const response = await axios.get(`${baseUrl}/api/user_company/user/${id}`)
        return response.data;
    } catch(err){
        console.error(err);
        return;
    }
}

export const getEventsByDate = async (date) => {
    const response = await axios.get(`${baseUrl}/api/events/date/${date}`)
    return response.data;
}

export const getCompanyById = async(id) => {
    try{
        const response = await axios.get(`${baseUrl}/api/companies/${id}`);
        return response.data;
    } catch(err){
        console.error(err);
        console.error('getCompanyById error');
        return;
    }
}

export const getEventsByCompanyId = async(id) => {
    try{
        const response = await axios.get(`${baseUrl}/api/events/company/${id}`);
        return response.data;
    } catch (err){
        console.error(err);
        console.error('getEventsByCompanyId error');
    }
}

export const postEvents = async (name, description, location, address, logo, attending = 0, category, date, cID = 0, postDate, time_with_zone, link = "", time_string, company=0) => {
    try {
        const response = await axios.post(`${baseUrl}/api/post/events2`, {
            name,
            description,
            location,
            address,
            logo,
            attending,
            category,
            date,
            cID,
            postDate,
            time_with_zone,
            link,
            time_string,
            company
        });
        // console.log("Response:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error posting event:", error);
        throw error;
    }
}

export const postCompany = async (id, name, address, description, phone, email, logo) => {
    try {
        const response = await axios.post(`${baseUrl}/api/post/companies`, {
            id,
            name,
            address,
            description,
            phone,
            email,
            logo
        });
        // console.log("Response", response.data);
        return response.data;
    } catch (error) {
        console.error("Error posting company:", error);
        throw error;
    }
}

export const sendEmail = async (formData) => {
    try {
        const response = await fetch(`${BASE_URL}/api/send-email`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        });

        const result = await response.json();

        if (response.ok) {
            console.log('Email sent successfully:');
        } else {
            console.error(response.status, result.message || 'Failed to send email');
        }
    } catch (err) {
        console.error(err);
    }
}

// // todo: delete
// export const createTempUser = async(dTE) => {
//     await axios.post(`${baseUrl}/api/post/user`, {
//       firstName: 'CEO3',
//       lastName: 'Smith3',
//       address: '123 Street3',
//       phone: '1234567893',
//       email: 'ceo@example3.com',
//       username: 'ceo3',
//       password: 'password3',
//       role: 'COMP3',
//       gender: 'Other3'
//     });
// }

// export const handleGeocode = async (address) => {
//     try {
//         const response = await axios.get(
//             `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(address)}&key=${apiKey}`
//         );
//
//         console.log(response)
//         if (response?.data?.results.length > 0) {
//             const { lat, lng } = response.data.results[0].geometry;
//             return { lat, lng };
//         } else {
//             // may delete this in case of clutter
//             console.log('No results found')
//         }
//     } catch (err) {
//         console.error('Error fetching location lat and lon');
//     }
// }

// this doesnt work //
export async function handleGeocode(address) {
    try {
        const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`
        );

        const data = await response.json();

        if (data.status === 'OK' && data.results.length > 0) {
            const { lat, lng } = data.results[0].geometry.location;
            return { lat, lng };
        } else {
            throw new Error('No results found.');
        }
    } catch (error) {
        console.error('Geocoding error:', error.message);
        throw new Error('Failed to fetch location.');
    }
}

export function convertToAmPm(timeString) {
    if (!timeString) return '';
    const [hourStr, minuteStr] = timeString.split(':');
    let hour = parseInt(hourStr, 10);
    const minute = minuteStr || '00';
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12; // Convert 0 to 12 for midnight
    return `${hour}:${minute.padStart(2, '0')} ${ampm}`;
}